import { render, staticRenderFns } from "./KPanel.vue?vue&type=template&id=c4a20a0c&"
import script from "./KPanel.vue?vue&type=script&lang=js&"
export * from "./KPanel.vue?vue&type=script&lang=js&"
import style0 from "./KPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports